import { combineReducers } from '@reduxjs/toolkit';
import filterParamsReducer from './filterParamsReducer';
const reducer = combineReducers({
    filterParamsReducer
});

export default reducer;
